import { useAppDispatch } from '../../../../app/store/configureStore';
import { createTableAsync, updateTableAsync } from '../store/tableSlice';
import { TableFormData } from '../types';
import { UseFormSetError } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

export const useTableForm = (restaurantId: string) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const handleFormSubmit = async (
    data: TableFormData,
    setError: UseFormSetError<TableFormData>,
    tableId?: string
  ) => {
    const formattedData = {
      tableNumber: data.tableNumber,
      status: data.status,
      capacity: data.capacity || 0,
      notes: data.notes || '',
    };

    try {
      if (tableId) {
        await dispatch(
          updateTableAsync({
            restaurantId,
            tableId,
            ...formattedData,
          })
        ).unwrap();
      } else {
        await dispatch(
          createTableAsync({
            restaurantId,
            ...formattedData,
          })
        ).unwrap();
      }
      return true;
    } catch (error: AxiosError | Error) {
      if (error.error?.code === 'DUPLICATE_TABLE_NUMBER') {
        setError('tableNumber', {
          type: 'manual',
          message: t('table.create.error.duplicateTableNumber'),
        });
        toast.error(t('table.create.error.duplicateTableNumber'));
      } else {
        // Handle other errors generically if needed
        toast.error(t('common.error'));
      }
      return false;
    }
  };

  return { handleFormSubmit };
};
